import { useTranslation } from 'react-i18next'
import { Confirmation } from '../../../../components'
import SettingsPushConfirmationBody from './PushConfirmationBody'
import { useSelector } from 'react-redux'
import { EstateUtils } from '../../../../utils'

type PushConfirmationProps = {
    acl: string
    children: JSX.Element
    confirmationMessage: string
    header: string
    inProgressMessage: string
    pushToAllDevices: () => void
    percentage?: number
} 

export default function PushConfirmation({
    acl,
    children,
    confirmationMessage,
    header,
    inProgressMessage,
    percentage,
    pushToAllDevices,
}: PushConfirmationProps) {
    const { t } = useTranslation()
    const hasPermissionToPush: boolean = useSelector(
        (state) => EstateUtils.hasPermission(state, { acls: [acl] })
    )

    if (!hasPermissionToPush) {
        return null
    }

    return (
        <Confirmation
            confirmation={
                <SettingsPushConfirmationBody
                    confirmationMessage={confirmationMessage}
                    inProgressMessage={inProgressMessage}
                    percentage={percentage}
                />
            }
            header={header}
            ok={t('ok')}
            cancel={t('cancel')}
            onCancel={percentage === undefined ? () => null : undefined}
            onConfirm={pushToAllDevices}
        >
            {children}
        </Confirmation>
    )
}